import ResetPwdPage from './ResetPwdPage'
export default ResetPwdPage